import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';
import { COCA_COLA_QUICK_PREVIEW } from '../fixtures/cocaColaQuick';

/*
 * Carrefour Coca-Cola Quick (24.08.2026 – 06.09.2026, 2 weeks). Built on the
 * same dashboard as "50 Ans" — same French stack, same Excel export, same
 * consent taxonomy — with the campaign's own report id.
 *
 * What this campaign does NOT have, per the design:
 *   - no game mechanic  → the Games & Missions tab and the "Games played" KPI
 *     are dropped (hide.gamesTab / hide.gamesPlayed)
 *   - no sponsor brands → campaign.brands is empty, so every brand widget and
 *     the per-brand table disappear on data alone (segmentsLocation omitted)
 *   - no sales data     → revenue / avg basket / users-traffic tiles hidden
 *
 * The reward is a Quick menu, so the pipeline sends the noun with the metrics
 * ("Menus earned", "Menu distribution") rather than the UI branching per report.
 */
export const cocaColaQuickConfig: DashboardConfig = {
  path: '/carrefour/coca-cola-quick',
  reportId: 'carrefour-coca-cola-quick',
  label: 'France · Coca-Cola Quick',
  endsOn: '2026-09-06', // 24 Aug → 6 Sep — archived from the day after
  apiBaseUrl: clusterBase('eu'),
  hide: {
    revenue: true,
    avgBasket: true,
    usersTraffic: true,
    itemsPerTx: true,
    gamesByBrand: true,
    topPrizes: true,
    gamesPlayed: true,
    gamesTab: true,
  },
  hasExport: true,
  // No coupons in this campaign — the design's tab reads "Rewards".
  tabLabels: { rewards: 'Rewards' },
  // Dev-only: review against the design until the pipeline ships. A deployed
  // build shows the loading/error panel instead — never handoff figures.
  devPreviewPayload: COCA_COLA_QUICK_PREVIEW,
};
